(function() {
  /**
   * @param {string} raw
   * @returns {string}
   */
  function toYoutubeEmbedUrl(raw) {
    const trimmed = String(raw || "").trim();
    if (!trimmed) return "";

    let u;
    try {
      u = new URL(trimmed);
    } catch {
      return "";
    }

    if (!/^https?:$/i.test(u.protocol)) return "";

    const host = u.hostname.replace(/^www\./i, "").toLowerCase();
    let id = "";

    if (host === "youtu.be") {
      id = u.pathname.replace(/^\//, "").split("/").filter(Boolean)[0] || "";
    } else if (host === "youtube.com" || host === "m.youtube.com" || host === "music.youtube.com") {
      if (u.pathname.startsWith("/watch")) {
        id = u.searchParams.get("v") || "";
      } else if (u.pathname.startsWith("/embed/")) {
        id = u.pathname.split("/")[2] || "";
      } else if (u.pathname.startsWith("/shorts/")) {
        id = u.pathname.split("/")[2] || "";
      }
    }

    if (!id || !/^[a-zA-Z0-9_-]{11}$/.test(id)) return "";

    return `https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
  }

  function resetSpecTabVideos(panel) {
    if (!panel) return;

    panel.querySelectorAll("[data-spec-video-frame]").forEach((frame) => {
      frame.hidden = true;
      frame.replaceChildren();
    });

    panel.querySelectorAll(".hk-spec-tabs__video-poster").forEach((el) => {
      el.hidden = false;
    });

    panel.querySelectorAll("[data-spec-video-open]").forEach((btn) => {
      btn.hidden = false;
    });
  }

  function initSpecTabVideos(root) {
    root.querySelectorAll("[data-spec-video]").forEach((wrap) => {
      if (wrap.dataset.specVideoBound === "true") return;

      const url = wrap.getAttribute("data-spec-video");
      const btn = wrap.querySelector("[data-spec-video-open]");
      const poster = wrap.querySelector(".hk-spec-tabs__video-poster");
      const frame = wrap.querySelector("[data-spec-video-frame]");

      if (!btn || !frame || !url) return;

      btn.addEventListener("click", () => {
        const embed = toYoutubeEmbedUrl(url);
        if (!embed) return;

        const iframe = document.createElement("iframe");
        iframe.src = embed;
        iframe.title = "YouTube video";
        iframe.loading = "lazy";
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute(
          "allow",
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        );

        frame.replaceChildren(iframe);
        frame.hidden = false;
        btn.hidden = true;
        if (poster) poster.hidden = true;
      });

      wrap.dataset.specVideoBound = "true";
    });
  }

  function initSpecTabs(root) {
    if (!root || root.dataset.specTabsReady === "true") {
      return;
    }

    const buttons = Array.from(root.querySelectorAll("[data-spec-tab-btn]"));
    const panels = Array.from(root.querySelectorAll("[data-spec-tab-panel]"));

    if (buttons.length === 0 || panels.length === 0) {
      return;
    }

    initSpecTabVideos(root);

    const activate = (index) => {
      buttons.forEach((btn) => {
        const active = btn.dataset.tabIndex === String(index);
        btn.classList.toggle("is-active", active);
        btn.setAttribute("aria-selected", active ? "true" : "false");
      });

      panels.forEach((panel) => {
        const active = panel.dataset.tabIndex === String(index);
        panel.classList.toggle("is-active", active);
        if (!active) {
          resetSpecTabVideos(panel);
        }
      });
    };

    const MOVE_PX = 12;

    buttons.forEach((btn) => {
      let start = null;
      let slided = false;

      btn.addEventListener("pointerdown", (e) => {
        if (e.pointerType === "mouse") {
          start = null;
          slided = false;
          return;
        }
        start = { x: e.clientX, y: e.clientY };
        slided = false;
      });

      btn.addEventListener(
        "pointermove",
        (e) => {
          if (start == null) return;
          if (e.pointerType === "mouse") return;
          if (Math.hypot(e.clientX - start.x, e.clientY - start.y) > MOVE_PX) {
            slided = true;
          }
        },
        { passive: true }
      );

      const end = (e) => {
        if (e.pointerType === "mouse") return;
        start = null;
      };
      btn.addEventListener("pointerup", end);
      btn.addEventListener("pointercancel", end);

      btn.addEventListener("click", (e) => {
        // iOS 上触摸后的 click 常带 pointerType "mouse"，故只以 slided 判断（真滑动后再忽略本次点击）
        if (slided) {
          e.preventDefault();
          e.stopImmediatePropagation();
          slided = false;
          return;
        }
        activate(btn.dataset.tabIndex);
      });
    });

    root.dataset.specTabsReady = "true";
  }

  function initAllSpecTabs() {
    document.querySelectorAll("[data-spec-tabs]").forEach(initSpecTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllSpecTabs);
  } else {
    initAllSpecTabs();
  }

  document.addEventListener("shopify:section:load", initAllSpecTabs);
})();
